export const PACKAGE_NAME = 'ameliance-scripts';
